import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { ChapterLabel, Reveal } from "@/components/landing/Reveal";
import { DESTINATIONS } from "@/lib/site";

const Destinations = () => (
    <section
        id="destinations"
        data-testid="destinations-section"
        className="mx-auto max-w-7xl px-5 py-24 md:px-10 md:py-36"
    >
        <Reveal>
            <ChapterLabel number="Nº 03" title="Destinations" testId="destinations-label" />
        </Reveal>
        <Reveal delay={0.1}>
            <h2 className="mt-8 max-w-3xl font-serif text-3xl font-medium leading-tight tracking-tight text-ivory md:text-5xl">
                WHERE ARE YOU GOING{" "}
                <span className="italic text-gold">TONIGHT?</span>
            </h2>
        </Reveal>

        <div className="mt-16 grid gap-6 md:grid-cols-2">
            {DESTINATIONS.map((d, i) => (
                <Reveal key={d.city} delay={0.05 + i * 0.06}>
                    <Link
                        data-testid={`destination-card-${d.slug}`}
                        to={`/destinations/${d.slug}`}
                        aria-label={`Explore ${d.city}`}
                        className="card-zoom group relative block h-[380px] overflow-hidden rounded-sm border border-white/10 md:h-[440px]"
                    >
                        <img
                            src={d.image}
                            alt={`${d.city} nightlife`}
                            loading="lazy"
                            className="absolute inset-0 h-full w-full object-cover"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/35 to-black/10 transition-colors duration-500 group-hover:via-black/20" />
                        <div className="absolute inset-x-0 bottom-0 p-8">
                            <h3 className="font-serif text-4xl font-medium tracking-tight text-ivory md:text-5xl">
                                {d.city}
                            </h3>
                            <p className="mt-3 max-w-sm text-sm leading-relaxed text-ivory/70">
                                {d.copy}
                            </p>
                            <span className="mt-5 inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.25em] text-gold">
                                Explore {d.city}
                                <ArrowRight
                                    size={14}
                                    strokeWidth={1.5}
                                    className="transition-transform duration-300 group-hover:translate-x-1.5"
                                />
                            </span>
                        </div>
                    </Link>
                </Reveal>
            ))}

            <Reveal delay={0.1} className="md:col-span-2">
                <div
                    data-testid="destination-card-coming-soon"
                    className="flex flex-col items-start justify-between gap-6 rounded-sm border border-dashed border-white/15 bg-[#0A0A0A] p-8 md:flex-row md:items-center md:p-10"
                >
                    <div>
                        <h3 className="font-serif text-2xl font-medium italic text-ivory md:text-3xl">
                            More Coming Soon
                        </h3>
                        <p className="mt-3 text-[11px] font-semibold uppercase tracking-[0.35em] text-muted">
                            Dubai <span className="mx-2 text-gold">•</span> Bali
                            <span className="mx-2 text-gold">•</span> Singapore
                            <span className="mx-2 text-gold">•</span> Ibiza
                        </p>
                    </div>
                    <p className="max-w-xs text-sm leading-relaxed text-muted">
                        The world's best nights, reserved — one city at a time.
                    </p>
                </div>
            </Reveal>
        </div>
    </section>
);

export default Destinations;
